// redux/reducers/categoryModalReducer.js
const initialState = {
    isModalVisible: false,
  };
  
  const attributeModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_CATEGORY_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_CATEGORY_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default attributeModalReducer;
  